import type { Directive } from 'vue';

/**
 * Applies a scrollbar visible class to a container if it has a scrollbar
 */
export const scrollBarVisible: Directive = {
    mounted(el) {
        el.resizeObserver = new ResizeObserver(() => {
            if (el.scrollHeight > el.clientHeight) {
                // The el has a scrollbar, add the class
                el.classList.add('scrollbar-visible');
            } else {
                // The el does not have a scrollbar, remove the class
                el.classList.remove('scrollbar-visible');
            }
        });
        el.resizeObserver.observe(el);
    },
    unmounted(el) {
        el.resizeObserver.disconnect();
    },
};
